module.exports = __webpack_public_path__ + "img/usa.2d73ab02.svg";